// src/Pages/Splash.js

import './Splash.css';
import SplashGraphics from '../Images/Earth_Frame_356_Processed.webp';

const Splash = () => {
  return (
    <div className='splash'>
      <div className='splash-graphics'>
        <img src={SplashGraphics} alt='Place Holder' />
      </div>
    </div>
  );
};

export default Splash;